import React from "react";
import ReactDOM from "react-dom";
import "regenerator-runtime/runtime";
import * as Flex from "@twilio/flex-ui";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import Logout from "./Logout";

const mountNode = document.getElementById("root");
/*** 7116 */
document.title = "Talk";
const secureOriginSFWY = window.appConfig.custom_data.secureOrigin
// function handleMessageFromParent(event) {
// console.log("Message received")
//   const secureOrigin =  secureOriginSFWY;
//   // if (event.origin !== secureOrigin) {
//   //   console.warn('Origin not allowed:', event.origin);
//   //   return;
//   // }
//   if (event.data.action === "maximizeWindow") {
//     if (document.documentElement.requestFullscreen) {
//       document.documentElement.requestFullscreen();
//     } else if (document.documentElement.mozRequestFullScreen) {
//       document.documentElement.mozRequestFullScreen(); // Firefox
//     } else if (document.documentElement.webkitRequestFullscreen) {
//       document.documentElement.webkitRequestFullscreen(); // Chrome, Safari
//     } else if (document.documentElement.msRequestFullscreen) {
//       document.documentElement.msRequestFullscreen(); // IE/Edge
//     }
//     window.resizeTo(event.data.width, event.data.height);
//     // Optionally, you can also move the window to a specific position on the screen
//     window.moveTo(0, 0);  // Move to the top-left corner of the screen
//     // Bring the window into focus
//     window.focus();
//   }
// }
window.onload = () => {
  /*** Loader */
  const outloader = document.createElement("div");
  outloader.className = "out-loader"; 
  const loader = document.createElement("div");
  loader.className = "loader";
  outloader.appendChild(loader);
  mountNode.appendChild(outloader);

  const predefinedConfig = window.appConfig || {};
  const checkPopupBlocked = () => {
    const testPopup = window.open("", "_blank", "width=1,height=1");
    if (testPopup === null) {
      return false;
    } else {
      testPopup.close();
      return true;
    }
  };
  if (window.parent && !window.parent.closed) {
    
    // console.log("This URL is opened in a subwindow (popup).");
    // Handle subwindow-specific logic here
  } else if (window.self !== window.top) {
    // console.log("This URL is opened in an iframe.");
    if (!checkPopupBlocked()) {
      const jsonData = {
        /*** 7116 */
        app: "Talk",
        action: "flex",
      };
      window.parent.postMessage(
        jsonData,
        window.appConfig.sfwyUrl
      );
      alert("Please enable pop-ups to use Voice Call");
  
      return;
    }
  }
  
  if(window.location.href.includes("logout")){
    ReactDOM.render(
      <Logout />,
      mountNode
    );
  } else {
    const configuration = {
      ...predefinedConfig,
    };

    Flex
      .progress(mountNode)
      .provideLoginInfo(configuration, mountNode)
      .then(() => Flex.Manager.create(configuration))
      .then(manager => renderApp(manager))
      .catch(error => handleError(error));
  };

  function renderApp(manager) {
    ReactDOM.render(
      <App manager={manager} />,
      mountNode
    );
  }
  // window.removeEventListener('message', handleMessageFromParent);
  // window.addEventListener('message', handleMessageFromParent);
      
}

function handleError(error) {
  const errorMessage = error?.message || "";
  if(errorMessage === 'Log in failed. Please contact your administrator and try again later.' ||
    errorMessage === 'We\'re not able to log you in right now - this might be due to an ongoing incident we\'re experiencing. Contact your administrator and try again later.'
  ) {
    const jsonData = {
      /*** 7116 */
      app: "Talk",
      action: "contact-center-login-closed",
    };

    window.parent.postMessage(
      jsonData,
      window.appConfig.sfwyUrl
    );
  } else {
    const jsonData = {
      /*** 7116 */
      app: "Talk",
      action: "c-contact-sso-fail",
    }
    window.parent.postMessage(
      jsonData,
      window.appConfig.sfwyUrl
    )
    console.error("Failed to initialize", error);
    Flex.errorPage(error, mountNode);
  }
}

registerServiceWorker();
